module.exports = __webpack_public_path__ + "static/media/pornography.047bc075.svg";